import { createStore } from 'vuex'

export default createStore({
  state: {
    // 搜索状态
    searchKeyword: '',
    searchType: '1', // 1=型号，2=编号
    searchTriggered: 0 // 用于触发搜索的计数器，每次搜索时递增
  },
  mutations: {
    // 设置搜索条件
    SET_SEARCH(state, payload: { keyword: string; searchType: string }) {
      state.searchKeyword = payload.keyword
      state.searchType = payload.searchType
      state.searchTriggered++
    },
    // 清除搜索条件
    CLEAR_SEARCH(state) {
      state.searchKeyword = ''
      state.searchType = '1'
      state.searchTriggered++ // 触发搜索以刷新列表
    }
  },
  actions: {
    // 执行搜索
    search({ commit }, payload: { keyword: string; searchType: string }) {
      commit('SET_SEARCH', payload)
    },
    // 清除搜索
    clearSearch({ commit }) {
      commit('CLEAR_SEARCH')
    }
  },
  getters: {
    // 获取搜索关键词
    searchKeyword: state => state.searchKeyword,
    // 获取搜索类型
    searchType: state => state.searchType,
    // 获取搜索触发计数器（用于监听搜索事件）
    searchTriggered: state => state.searchTriggered
  },
  modules: {
  }
})
